import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListsService } from '@app/lists/services/lists.service';
import { UserPhoto } from '@shared/services/photo/model/photo.model';
import { CameraSquareActions } from './camera-square-actions.enum';

@Component({
  selector: 'app-camera-uploader-square',
  templateUrl: './camera-uploader-square.component.html',
  styleUrls: ['./camera-uploader-square.component.scss'],
})
export class CameraUploaderSquareComponent {
  @Output() squareClicked = new EventEmitter();
  @Input() index: number;
  @Input() photo: UserPhoto | any;
  @Input() photos: UserPhoto[];
  @Input() errorState: string;
  @Input() showAddText: boolean;
  cameraActions = CameraSquareActions;

  constructor() {}

  handleSquareClicked(action: string) {
    this.squareClicked.emit(action);
  }
}
